import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Carousel from '../Carousel';
import ListingCard from './ListingCard';
import DummyCard from './DummyCard';
import EdapModuleView from '../EdapModuleView';
import { Experiment } from '../Experiment';
import { DUMMY_CARD_ICONS } from './constants';

import {
  handleEdapClick,
  triggerEdapEvent
} from '../../utils/edap';

import {
  RECENTACTIVITY_VIEW,
  NAV_PREVIOUS_CLICK,
  NAV_NEXT_CLICK,
  MODULE_VIEW_EVENT_OPTIONS
} from './events';

class RecentTravelerActivity extends PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    isMobile: PropTypes.bool.isRequired,
    limit: PropTypes.number,
    title: PropTypes.string,
    fetchRecentActivity: PropTypes.func
  }

  static defaultProps = {
    data: [],
    title: 'Pick up where you left off',
    limit: 8,
    fetchRecentActivity: () => {}
  }

  constructor(props) {
    super(props);
    this.state = { blankSpaces: 0 };
  }

  componentDidMount() {
    this.props.fetchRecentActivity({ limit: this.props.limit });
  }

  getNumberOfBlankSpaces(visibleItems) {
    const totalCards = this.props.data.length;
    return totalCards < visibleItems ? visibleItems - totalCards : 0;
  }

  renderDummyCards(cards) {
    const { isMobile } = this.props;
    const { blankSpaces } = this.state;

    return !isMobile
      ? cards.slice(0, blankSpaces).map((icon, index) => <DummyCard key={index} svgIcon={icon} />)
      : [];
  }

  handlePreviousClick = () => {
    triggerEdapEvent(NAV_PREVIOUS_CLICK);
  }

  handleNextClick = () => {
    triggerEdapEvent(NAV_NEXT_CLICK);
  }

  handleOnResize = ({ numberCardsVisible }) => {
    if (!this.props.isMobile) {
      this.setState({
        blankSpaces: this.getNumberOfBlankSpaces(numberCardsVisible)
      });
    }
  }

  render() {
    const {
      data,
      title
    } = this.props;

    return (
      !!data.length &&
      <Experiment name={'HA_PTA_HP_RecentActivityOptimizationV2'} report>
        <section className="Content__section">
          <EdapModuleView eventOptions={MODULE_VIEW_EVENT_OPTIONS}>
            <Carousel
              title={title}
              onPreviousClick={this.handlePreviousClick}
              onNextClick={this.handleNextClick}
              onResize={this.handleOnResize}
            >
              {[
                ...data.map(({ listingId, lbsUuid, ...listingData }) => (
                  <ListingCard
                    key={lbsUuid}
                    onClick={handleEdapClick(RECENTACTIVITY_VIEW, { listingid: listingId, eventlbsuuid: lbsUuid })}
                    {...listingData}
                  />
                )),
                ...this.renderDummyCards(DUMMY_CARD_ICONS)
              ]}
            </Carousel>
          </EdapModuleView>
        </section>
      </Experiment>
    );
  }
}

export default RecentTravelerActivity;
